import logo from './../../../Styles/images/logo.png'
import pvHorizontal from './../../../Styles/Logos/PVHorizontal.png';
import React, {useState} from "react";
import Image, { propTypes } from "react-bootstrap/Image";
import { Container,Row,Col, Card, Table,Tab,Tabs, Badge, Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import './../../../Styles/Admin.css';
import { WadiStyles } from '../../../Styles/WadiStyles';
import PropTypes from 'prop-types';

import AdminDashboardTableComponent from './AdminDashboardTableComponent';
import AdminDashboardMonthViewComponent from './AdminDashboardMonthComponent';
import AdminDashboardEditComponent from './AdminDashboardEditComponent';




const TableViewControllerComponent = props => {

    switch(props.view){
        case'Month':
            return(
            <>
                 <Row>
                    <Col>
                        <AdminDashboardMonthViewComponent week ={'1'}/>
                    </Col>
                    <Col>
                        <AdminDashboardMonthViewComponent week ={'2'}/>
                    </Col>
                    <Col>
                        <AdminDashboardMonthViewComponent week ={'3'}/>
                    </Col>
                    <Col>
                        <AdminDashboardMonthViewComponent week ={'4'}/>
                    </Col>
                </Row>
                
            </>);
        case'Edit':
            return(
                <>
                    <AdminDashboardEditComponent hours={props.hours} locations={props.locations} editing={props.editing}></AdminDashboardEditComponent>
                    <Row>
                        <Col style={{paddingTop:'1vh', alignContent:'right',alignItems:'right', justifyContent:'right',display:'flex'}}>
                            <Button style={WadiStyles.dashboard.button}>Save</Button>
                        </Col>
                    </Row>
                </>
            )
        
        case'Day':
            return(
                <>
                    <AdminDashboardTableComponent updateView={props.updateView} hours={props.hours} locations={props.locations} bookingMapping={props.bookingMapping}/>
                </>
            );
        default:
            return(
                <>
                    <AdminDashboardTableComponent updateView={props.updateView} hours={props.hours} locations={props.locations} bookingMapping={props.bookingMapping}/>
                </>
            );
    }
}

TableViewControllerComponent.defaultProps = {

}
TableViewControllerComponent.propTypes = {
    view: PropTypes.string,
    updateView:PropTypes.func,

    hours: PropTypes.arrayOf(String),
    locations: PropTypes.arrayOf(Map),
    bookingMapping: PropTypes.arrayOf(Map),
}


const AdminDashboardComponent = props => {
    function handleClick(selection){
        props.updateView(selection)
    }
    /** Below data will be replaced with DB demo info */
    const hours = ["10 AM","11:15 AM","11:30 AM", "11:45 AM","12 PM","12:15 PM","12:30 PM", "12:45 PM","1 PM","1:15 PM","1:30 PM", "1:45 PM","2 PM","2:15 PM","2:30 PM", "2:45 PM","3 PM","3:15 PM","3:30 PM", "3:45 PM"];
    let bookingMapping = [{time:"11 AM",name:"The Watson Party",location:"barrel",size:4},{time:"11:45 AM",name:"The Smithe Party",location:"barrel",size:2},{time:"12:30 PM",name:"The Jamali Party",location:"barrel",size:3}, {time:"3:30 PM", name:"The Johnson Party",location:"barrel",size:2}];
    let locations =[{name:"Barrel Room", bookedHours:["11:30 AM", "12 PM","12:15 PM","12:30 PM", "3 PM"]},{name:"Overlook", bookedHours:["11 AM", "11:15 AM","12:15 PM","12:45 PM", "3:30 PM"]}, {name:"Gazebo", bookedHours:["11 AM", "1:15 PM","12:15 PM","1:30 PM", "2 PM"]}];
    let editing = {party:'Watson', size:'4',time:'11 AM', location:'Overlook'}

    return(
    <>
        <Container style ={{padding:'1vh'}}>
            <Row>
                <Col sm='2'>
                    <Dropdown>
                        <Dropdown.Toggle
                        variant="sucess"
                        id="dropdown-basic"
                        style={WadiStyles.dashboard.dropdown}>
                            {props.view}
                        </Dropdown.Toggle>
                        <Dropdown.Menu style={WadiStyles.dashboard.dropdownBody}>
                            <Dropdown.Item onClick={()=>handleClick('Day')}>Day</Dropdown.Item>
                            <Dropdown.Item onClick={()=>handleClick('Month')}>Month</Dropdown.Item>
                            {/** Temp To build editing Look and feel without onclick functionality */}
                            <Dropdown.Item onClick={()=>handleClick('Edit')}>Edit</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
           
        </Container>
        
        <Container style ={{backgroundColor:'#e7ebe5', borderRadius:'10px', padding:'1vh', paddingRight:'1vw', paddingLeft:'1vw'}}>
               <TableViewControllerComponent view={props.view} updateView={props.updateView} hours={hours} bookingMapping={bookingMapping} locations={locations} editing={editing}/>
        </Container>
    
    </>
    )

}

AdminDashboardComponent.defaultProps = {

}
AdminDashboardComponent.propTypes = {
    subtab: PropTypes.string,
    updateSubTab:PropTypes.func,

    view: PropTypes.string,
    updateView:PropTypes.func,
}

export default (AdminDashboardComponent);